module.exports = __webpack_public_path__ + "static/media/icon-checkmark.4912fd40.svg";